export enum OrderStatusTypes {
    PENDING = 1,
    DELIVERED = 2,
    CANCELLED = 3,
    DELAYED = 4,
}